export const COMPONENT_NAME = 'HORIZON_TABLE_';
export const TABLE_CHANGE = COMPONENT_NAME + 'TABLE_CHANGE';
export const ROWS_RECEIVED = COMPONENT_NAME + 'ROWS_RECEIVED';
export const DELETE_SELECTED = COMPONENT_NAME + 'DELETE_SELECTED';
export const ENABLE_SELECTED = COMPONENT_NAME + 'ENABLE_SELECTED';
export const DISABLE_SELECTED = COMPONENT_NAME + 'DISABLE_SELECTED';
export const LAST_TABLE_OPENED = COMPONENT_NAME + 'LAST_TABLE_OPENED';
